module.exports = __webpack_public_path__ + "img/average-top-arrow.099117d9.svg";